import React, { useState } from "react";
import Box from "@mui/material/Box";
import InputLabel from "@mui/material/InputLabel";
import MenuItem from "@mui/material/MenuItem";
import FormControl from "@mui/material/FormControl";
import Select, { SelectChangeEvent } from "@mui/material/Select";
import { useTheme } from "@mui/material";
import { MarketTreeMapStyle } from "./MarketTreeMap.styles";
import { hideCoin, useTreeMapFilterState } from "src/store/features/MarketTreeMapFilter.slice";
import { useAppDispatch } from "src/store/store";
import { trackEvent } from "src/Amplitude";

const ITEM_HEIGHT = 48;
const ITEM_PADDING_TOP = 8;
const MenuProps = {
  PaperProps: {
    style: {
      maxHeight: ITEM_HEIGHT * 4.5 + ITEM_PADDING_TOP,
      width: 200,
    },
  },
};

export default function MarketTreeMapFilter() {
  // ------------------State---------------------------
  const [coinName, setCoinName] = useState<string[]>([]);
  const { treemapCoins, hideCoins } = useTreeMapFilterState();

  // ------------------_REDUX---------------------------
  const dispatch = useAppDispatch();
  // ------------------Style Sheet---------------------------
  const classes = MarketTreeMapStyle();
  const theme = useTheme();

  const handleChange = (event: SelectChangeEvent<typeof coinName>) => {
    const {
      target: { value },
    } = event;

    dispatch(hideCoin(typeof value === "string" ? value.split(",") : value));
    setCoinName(
      // On autofill we get a stringified value.
      typeof value === "string" ? value.split(",") : value,
    );
  };

  return (
    <FormControl size="small" sx={{ width: { xs: "100%", sm: "100%", md: "100%" } }}>
      <InputLabel shrink={false}>Hide</InputLabel>
      <Select
        multiple
        value={hideCoins}
        MenuProps={MenuProps}
        onChange={handleChange}
        sx={{
          "&.MuiOutlinedInput-root": {
            "& fieldset": {},
            "&:hover fieldset": {
              borderColor: theme.palette.secondary.main,
            },
            "&.Mui-focused fieldset": {
              borderColor: theme.palette.secondary.main,
            },
          },
        }}
        renderValue={(selected) => (
          <Box
            sx={{
              display: "flex",
              marginTop: "3px",
              flexWrap: "wrap",
              gap: 0.5,
            }}></Box>
        )}>
        {treemapCoins &&
          [...treemapCoins]?.sort().map((name: string, ind: number) => (
            <MenuItem
              onClick={() =>
                trackEvent(`Select_Market_Sectors_Page_Advanced_Options_Hide`, {
                  option: name,
                })
              }
              className={classes.menuDropDown}
              key={ind}
              value={name}>
              {name}
            </MenuItem>
          ))}
      </Select>
    </FormControl>
  );
}

// change date to performance
// add min button
